<template>
    <transition name="fade">
        <div v-if="visible" class="preloader">
            <img src="../assets/images/logo-air.png">
        </div>
    </transition>
</template>

<script>

    import EventBus from "./EventBus";

    export default {
        name: "Preloader",
        data() {
            return {
                visible: true
            }
        },
        mounted() {
            EventBus.$on("PRELOADER_SHOW", () => this.visible = true);
            EventBus.$on("PRELOADER_HIDE", () => this.visible = false);
        }
    }
</script>

<style lang="less" scoped>

    .preloader {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 10000;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
            max-width: 200px;
            transform: scale(1);
            animation: pulse 1s infinite;
        }
    }

    @keyframes pulse {
        0% {
            transform: scale(0.9);
        }
        50% {
            transform: scale(1);
        }
        100% {
            transform: scale(0.9);
        }
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>